"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalDriveModeDefinitionSchema = exports.DriveModeValueParamsSchema = exports.ISignalDriveModeConditionSchema = exports.ISignalDriveBiasSchema = exports.IVoltageReferenceBiasSchema = exports.ISignalReferenceBiasSchema = exports.SignalDriveBiasBaseSchema = exports.SignalDriveTypeSchema = exports.SignalInputDriveType = exports.SignalOutputDriveType = void 0;
const RelativeSignal_1 = require("../RelativeSignal");
const zod_1 = require("zod");
const zod_field_presence_1 = require("../Utils/zod-field-presence");
var SignalOutputDriveType;
(function (SignalOutputDriveType) {
    SignalOutputDriveType["OpenDrain"] = "open-drain";
    SignalOutputDriveType["OpenSource"] = "open-source";
    SignalOutputDriveType["OpenCollector"] = "open-collector";
    SignalOutputDriveType["OpenEmitter"] = "open-emitter";
    SignalOutputDriveType["PushPull"] = "push-pull";
})(SignalOutputDriveType || (exports.SignalOutputDriveType = SignalOutputDriveType = {}));
var SignalInputDriveType;
(function (SignalInputDriveType) {
    SignalInputDriveType["HighZ"] = "high-z";
})(SignalInputDriveType || (exports.SignalInputDriveType = SignalInputDriveType = {}));
exports.SignalDriveTypeSchema = zod_1.z.nativeEnum({ ...SignalOutputDriveType, ...SignalInputDriveType });
exports.SignalDriveBiasBaseSchema = zod_1.z.object({
    impedance: (0, zod_field_presence_1.coercedString)(),
});
exports.ISignalReferenceBiasSchema = zod_1.z.object({
    type: zod_1.z.literal('signal'),
    impedance: (0, zod_field_presence_1.coercedString)(),
    signalReference: RelativeSignal_1.RelativeSignalSchema,
});
exports.IVoltageReferenceBiasSchema = zod_1.z.object({
    type: zod_1.z.literal('voltage'),
    impedance: (0, zod_field_presence_1.coercedString)(),
    voltageReference: zod_1.z.number(),
});
exports.ISignalDriveBiasSchema = zod_1.z.discriminatedUnion('type', [
    exports.ISignalReferenceBiasSchema,
    exports.IVoltageReferenceBiasSchema,
]);
exports.ISignalDriveModeConditionSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    condition: (0, zod_field_presence_1.allowingAbsentKey)(zod_1.z.custom()),
});
exports.DriveModeValueParamsSchema = zod_1.z.object({
    outputHighVoltage: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    outputLowVoltage: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    inputHighVoltage: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    inputLowVoltage: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    internalPullupBias: exports.ISignalDriveBiasSchema.optional(),
    internalPulldownBias: exports.ISignalDriveBiasSchema.optional(),
    outputImpedance: zod_1.z.coerce.string().optional(),
});
exports.SignalDriveModeDefinitionSchema = zod_1.z.object({
    type: exports.SignalDriveTypeSchema,
    parameters: exports.DriveModeValueParamsSchema.optional(),
    conditions: zod_1.z.array(exports.ISignalDriveModeConditionSchema).optional(),
});
//# sourceMappingURL=SignalDriveMode.js.map